import { render, staticRenderFns } from "./inflammation1.vue?vue&type=template&id=712d6952&scoped=true&"
import script from "./inflammation1.vue?vue&type=script&lang=js&"
export * from "./inflammation1.vue?vue&type=script&lang=js&"
import style0 from "./inflammation1.vue?vue&type=style&index=0&id=712d6952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d6952",
  null
  
)

export default component.exports